import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
  useForm,
} from "react";
import {
  Card,
  Pagination,
  Button,
  ConfigProvider,
  Input,
  Select,
  Form,
  Modal,
  Col,
} from "antd";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import { useHistory } from "react-router-dom";
import ServiceApplication from "./ServiceApplication";
import ImbarkBase from "./ImbarkBase";
import EntrepreneurialExpert from "./EntrepreneurialExpert";
import FinancialService from "./FinancialService";
import "./index.scss";
import { getDictOne } from "../../utils/storage";
import one from "../../images/home/one.png";
import two from "../../images/home/two.png";
import three from "../../images/home/three.png";
import zh_CN from "antd/es/locale/zh_CN";
const { TextArea } = Input;
const { Search } = Input;
const { Option } = Select;
const industry = getDictOne("industry_code");
const region = [
  { city: "创业服务申请", id: 1 },
  // { city: "创业基地", id: 2 }, 18090 就业创业网门户--首页，创业帮扶分为创业资金申请，创业服务支持和创业优惠政策三个板块，取消“创业基地”板块
  { city: "创业专家", id: 3 },
  { city: "创业金融服务", id: 4 },
];

function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <a>上一页</a>;
  }
  if (type === "next") {
    return <a>下一页</a>;
  }
  return originalElement;
}
const data = [
  { text: "农业", id: 1 },
  { text: "地产", id: 2 },
  { text: "金融", id: 3 },
  { text: "运输业", id: 4 },
  { text: "餐饮", id: 5 },
  { text: "制造业", id: 6 },
];
export default function JobCollection(props) {
  const [currentPage, setCurrentPage] = useState(1); //当前页数

  const [searchValue, setSearchValue] = useState(""); //搜索框value值
  const [currentCity, setCurrentCity] = useState(1); //城市
  const [currentCityTwo, setCurrentCityTwo] = useState("创业金融服务");
  const [countyLevel, setCountyLevel] = useState(0); //眉山市或其他市
  const [succeed, setSucceed] = useState(0); //收藏
  const [succeedTwo, setSucceedTwo] = useState(0); //收藏
  const [moneyList, setMoneyList] = useState([]); //发行机构
  const [selectValue, setSelectValue] = useState("");

  const history = useHistory();

  useEffect(() => {
    const { location } = history;
    if (location.params && location.params.activeyKey) {
      setCurrentCity(location.params.activeyKey - 0);
    }
  }, [history]);

  const handleChangeCity = useCallback((value, city) => {
    console.log("value", value, city);
    setSearchValue("");
    setCurrentCityTwo(city);
    setCurrentCity(value);
  }, []);

  const regionsearch = useCallback(() => {
    return region.map((item, index) => {
      return (
        <span
          onClick={() => {
            handleChangeCity(item.id, item.city);
          }}
          className={
            currentCity === item.id ? "currentCity" : "currentCity_two"
          }
        >
          {item.city}
        </span>
      );
    });
  }, [currentCity, handleChangeCity]);
  const onSearch = (value) => {
    setSearchValue(value);
  };
  //改变selectValue
  const handleSelectValue = useCallback((e) => {
    setSelectValue(e);
  }, []);

  useEffect(() => {
    Http.get(Request.moneyList(), {}, (obj) => {
      if (obj.code == 200) {
        console.log("objobjobj", obj);
        setMoneyList(obj.data);
      }
    });
  }, []);

  useEffect(() => {
    handleChangeCity(4, "创业金融服务");
  }, [handleChangeCity, history]);

  return (
    (
      <div className={"createAssist_app"}>
        <div
          className={"getjob_Search"}
          style={{ padding: "16px 0", background: "#FBFBFB" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <span>当前位置：创业帮扶 / </span>
              <span style={{ color: "#3356C5", cursor: "pointer" }}>
                {" "}
                {currentCityTwo}
              </span>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 30 }}>
            {/* <div>{regionsearch()}</div> */}
            <div>
              <div>
                <Input.Group compact style={{ display: "flex" }}>
                  <Form.Item
                    style={{ display: "flex" }}
                    name="gender"
                    label="发布机构"
                    rules={[{ required: true }]}
                  >
                    <Select
                      className={"getjob_top_select"}
                      onChange={handleSelectValue}
                      style={{ width: 150 }}
                      defaultValue="全部"
                      placeholder="请选择发行机构"
                      allowClear
                    >
                      <Option value="0">全部</Option>
                      {moneyList && moneyList.length
                        ? moneyList.map((item) => {
                            return (
                              <Option key={item.id} value={item.userId}>
                                {item.auditMechanismName}
                              </Option>
                            );
                          })
                        : ""}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    style={{ display: "flex", marginLeft: "10px" }}
                    name="gender"
                    label="关键字"
                    rules={[{ required: true }]}
                  >
                    <Search
                      style={{ width: "300px" }}
                      placeholder="搜索金融产品名称"
                      allowClear
                      enterButton="搜索"
                      size="large"
                      onSearch={onSearch}
                    />
                  </Form.Item>
                </Input.Group>
              </div>
            </div>
          </div>
        </div>
        <div className={"getjob_major"}>
          <FinancialService search={searchValue} select={selectValue} />
        </div>
      </div>
    )
  );
}
